__turbopack_context__.v({
  "bodyCopy": "RoadmapPage-module__6PH38q__bodyCopy",
  "brand": "RoadmapPage-module__6PH38q__brand",
  "brandWordmark": "RoadmapPage-module__6PH38q__brandWordmark",
  "callout": "RoadmapPage-module__6PH38q__callout",
  "calloutPurple": "RoadmapPage-module__6PH38q__calloutPurple",
  "card": "RoadmapPage-module__6PH38q__card",
  "cardBody": "RoadmapPage-module__6PH38q__cardBody",
  "cardGrid": "RoadmapPage-module__6PH38q__cardGrid",
  "cardLabel": "RoadmapPage-module__6PH38q__cardLabel",
  "cardTitle": "RoadmapPage-module__6PH38q__cardTitle",
  "cardTitleTight": "RoadmapPage-module__6PH38q__cardTitleTight",
  "chapterNav": "RoadmapPage-module__6PH38q__chapterNav",
  "closingQuote": "RoadmapPage-module__6PH38q__closingQuote",
  "closingQuoteWrap": "RoadmapPage-module__6PH38q__closingQuoteWrap",
  "desktopNav": "RoadmapPage-module__6PH38q__desktopNav",
  "desktopOnly": "RoadmapPage-module__6PH38q__desktopOnly",
  "directionBody": "RoadmapPage-module__6PH38q__directionBody",
  "directionContent": "RoadmapPage-module__6PH38q__directionContent",
  "directionList": "RoadmapPage-module__6PH38q__directionList",
  "directionNumber": "RoadmapPage-module__6PH38q__directionNumber",
  "directionRow": "RoadmapPage-module__6PH38q__directionRow",
  "directionTitle": "RoadmapPage-module__6PH38q__directionTitle",
  "eyebrow": "RoadmapPage-module__6PH38q__eyebrow",
  "featureDescription": "RoadmapPage-module__6PH38q__featureDescription",
  "featureName": "RoadmapPage-module__6PH38q__featureName",
  "featureRow": "RoadmapPage-module__6PH38q__featureRow",
  "featureTable": "RoadmapPage-module__6PH38q__featureTable",
  "finePrint": "RoadmapPage-module__6PH38q__finePrint",
  "goldHighlight": "RoadmapPage-module__6PH38q__goldHighlight",
  "header": "RoadmapPage-module__6PH38q__header",
  "headerActions": "RoadmapPage-module__6PH38q__headerActions",
  "headerDivider": "RoadmapPage-module__6PH38q__headerDivider",
  "headerInner": "RoadmapPage-module__6PH38q__headerInner",
  "hero": "RoadmapPage-module__6PH38q__hero",
  "heroActions": "RoadmapPage-module__6PH38q__heroActions",
  "heroInner": "RoadmapPage-module__6PH38q__heroInner",
  "heroReveal1": "RoadmapPage-module__6PH38q__heroReveal1",
  "heroReveal2": "RoadmapPage-module__6PH38q__heroReveal2",
  "heroReveal3": "RoadmapPage-module__6PH38q__heroReveal3",
  "heroReveal4": "RoadmapPage-module__6PH38q__heroReveal4",
  "heroReveal5": "RoadmapPage-module__6PH38q__heroReveal5",
  "heroSubtitle": "RoadmapPage-module__6PH38q__heroSubtitle",
  "heroTitle": "RoadmapPage-module__6PH38q__heroTitle",
  "lede": "RoadmapPage-module__6PH38q__lede",
  "ledeSection": "RoadmapPage-module__6PH38q__ledeSection",
  "liveDot": "RoadmapPage-module__6PH38q__liveDot",
  "main": "RoadmapPage-module__6PH38q__main",
  "menuButton": "RoadmapPage-module__6PH38q__menuButton",
  "metaLabel": "RoadmapPage-module__6PH38q__metaLabel",
  "metaRow": "RoadmapPage-module__6PH38q__metaRow",
  "metaTable": "RoadmapPage-module__6PH38q__metaTable",
  "metaValue": "RoadmapPage-module__6PH38q__metaValue",
  "mobileLink": "RoadmapPage-module__6PH38q__mobileLink",
  "mobileLinks": "RoadmapPage-module__6PH38q__mobileLinks",
  "mobilePanel": "RoadmapPage-module__6PH38q__mobilePanel",
  "mobilePanelOpen": "RoadmapPage-module__6PH38q__mobilePanelOpen",
  "mobileToggle": "RoadmapPage-module__6PH38q__mobileToggle",
  "navLink": "RoadmapPage-module__6PH38q__navLink",
  "navLinks": "RoadmapPage-module__6PH38q__navLinks",
  "noteText": "RoadmapPage-module__6PH38q__noteText",
  "outOfScopeItem": "RoadmapPage-module__6PH38q__outOfScopeItem",
  "outOfScopeList": "RoadmapPage-module__6PH38q__outOfScopeList",
  "outOfScopeMark": "RoadmapPage-module__6PH38q__outOfScopeMark",
  "outOfScopeText": "RoadmapPage-module__6PH38q__outOfScopeText",
  "page": "RoadmapPage-module__6PH38q__page",
  "phaseArrow": "RoadmapPage-module__6PH38q__phaseArrow",
  "phaseAside": "RoadmapPage-module__6PH38q__phaseAside",
  "phaseBlock": "RoadmapPage-module__6PH38q__phaseBlock",
  "phaseBullet": "RoadmapPage-module__6PH38q__phaseBullet",
  "phaseBullets": "RoadmapPage-module__6PH38q__phaseBullets",
  "phaseChip": "RoadmapPage-module__6PH38q__phaseChip",
  "phaseContent": "RoadmapPage-module__6PH38q__phaseContent",
  "phaseDescriptor": "RoadmapPage-module__6PH38q__phaseDescriptor",
  "phaseGrid": "RoadmapPage-module__6PH38q__phaseGrid",
  "phaseIntro": "RoadmapPage-module__6PH38q__phaseIntro",
  "phaseList": "RoadmapPage-module__6PH38q__phaseList",
  "phaseName": "RoadmapPage-module__6PH38q__phaseName",
  "phaseParagraph": "RoadmapPage-module__6PH38q__phaseParagraph",
  "phaseParagraphs": "RoadmapPage-module__6PH38q__phaseParagraphs",
  "phaseSection": "RoadmapPage-module__6PH38q__phaseSection",
  "phaseSectionHeading": "RoadmapPage-module__6PH38q__phaseSectionHeading",
  "phaseTimeline": "RoadmapPage-module__6PH38q__phaseTimeline",
  "primaryButton": "RoadmapPage-module__6PH38q__primaryButton",
  "progressBar": "RoadmapPage-module__6PH38q__progressBar",
  "progressFill": "RoadmapPage-module__6PH38q__progressFill",
  "revealHint": "RoadmapPage-module__6PH38q__revealHint",
  "roadmap-fade-up": "RoadmapPage-module__6PH38q__roadmap-fade-up",
  "roadmap-flow": "RoadmapPage-module__6PH38q__roadmap-flow",
  "roadmap-pulse": "RoadmapPage-module__6PH38q__roadmap-pulse",
  "scrollIndicator": "RoadmapPage-module__6PH38q__scrollIndicator",
  "scrollPrompt": "RoadmapPage-module__6PH38q__scrollPrompt",
  "scrollText": "RoadmapPage-module__6PH38q__scrollText",
  "secondaryButton": "RoadmapPage-module__6PH38q__secondaryButton",
  "section": "RoadmapPage-module__6PH38q__section",
  "sectionBody": "RoadmapPage-module__6PH38q__sectionBody",
  "sectionHeader": "RoadmapPage-module__6PH38q__sectionHeader",
  "sectionLead": "RoadmapPage-module__6PH38q__sectionLead",
  "sectionTitle": "RoadmapPage-module__6PH38q__sectionTitle",
  "sectionWide": "RoadmapPage-module__6PH38q__sectionWide",
  "summaryText": "RoadmapPage-module__6PH38q__summaryText",
  "tokenIntro": "RoadmapPage-module__6PH38q__tokenIntro",
  "utilityCard": "RoadmapPage-module__6PH38q__utilityCard",
  "utilityCardContent": "RoadmapPage-module__6PH38q__utilityCardContent",
  "utilityDescription": "RoadmapPage-module__6PH38q__utilityDescription",
  "utilityGhostNumber": "RoadmapPage-module__6PH38q__utilityGhostNumber",
  "utilityGrid": "RoadmapPage-module__6PH38q__utilityGrid",
  "utilityIconSvg": "RoadmapPage-module__6PH38q__utilityIconSvg",
  "utilityIconWrap": "RoadmapPage-module__6PH38q__utilityIconWrap",
  "utilityIntro": "RoadmapPage-module__6PH38q__utilityIntro",
  "utilitySectionLabel": "RoadmapPage-module__6PH38q__utilitySectionLabel",
  "utilitySectionLabelWrap": "RoadmapPage-module__6PH38q__utilitySectionLabelWrap",
  "utilitySectionRule": "RoadmapPage-module__6PH38q__utilitySectionRule",
  "utilityStackItem": "RoadmapPage-module__6PH38q__utilityStackItem",
  "utilityTitle": "RoadmapPage-module__6PH38q__utilityTitle",
  "visionCopy": "RoadmapPage-module__6PH38q__visionCopy",
  "visionCopyWrap": "RoadmapPage-module__6PH38q__visionCopyWrap",
  "visionDirectionSection": "RoadmapPage-module__6PH38q__visionDirectionSection",
  "visionDot": "RoadmapPage-module__6PH38q__visionDot",
  "visionDotActive": "RoadmapPage-module__6PH38q__visionDotActive",
  "visionDots": "RoadmapPage-module__6PH38q__visionDots",
  "visionEyebrow": "RoadmapPage-module__6PH38q__visionEyebrow",
  "visionFrame": "RoadmapPage-module__6PH38q__visionFrame",
  "visionSection": "RoadmapPage-module__6PH38q__visionSection",
  "visionState": "RoadmapPage-module__6PH38q__visionState",
  "visionSticky": "RoadmapPage-module__6PH38q__visionSticky",
});
